import React from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Site, SiteSurveyTemplate, rng } from "../../amorg-common";
import { getAllSites, getSiteSurveyTemplates, importGlobalSurveyTemplate } from "../../api/adminClientApi";
import { LoadingPageOverlay } from "../../designSystem/LoadingPageOverlay";
import { SelectField } from "../../designSystem/formField/SelectField";
import { H1, H2 } from "../../designSystem/typography/Heading";
import { AmorgAdminPageProvider } from "./AmorgAdminPageContext";
import { Flex } from "../../designSystem/compositeComponents/FlexHelpers";
import { SingleColumnLayout } from "../../designSystem/layouts/SingleColumnLayout";
import { AdminTab } from "./_components/AdminTab";
import { SurveyTemplateList } from "./_components/SurveyTemplateList";

export function AmorgAdminImportTemplate (): JSX.Element
{
    const history = useHistory();

    const [loading, setLoading] = React.useState(true);

    const [sites, setSites] = React.useState<Site[]>([]);
    const [selectedSite, setSelectedSite] = React.useState("");

    const [siteTemplates, setSiteTemplates] = React.useState<SiteSurveyTemplate[]>([]);

    useEffect(() =>
    {
        const init = async () =>
        {
            const sites = await getAllSites(() => history.push(`/amorgy/login`));
            if (sites.length > 0)
            {
                setSites(sites);
                setSelectedSite(sites[0].id);
                setSiteTemplates(await getSiteSurveyTemplates(sites[0].id, () => history.push(`/amorgy/login`)));
            }

            setLoading(false);
        };
        init().catch(console.error);
    }, []);

    async function handleSiteChange (siteId: string)
    {
        setLoading(true);
        setSelectedSite(siteId);
        setSiteTemplates(await getSiteSurveyTemplates(siteId, () => history.push(`/amorgy/login`)));
        setLoading(false);
    }

    function handleClickImport (templateId: string)
    {
        setLoading(true);
        importGlobalSurveyTemplate(
            selectedSite,
            templateId,
            rng.getRandomId(),
            'global',
            () => history.push(`/amorgy/login`)
        ).then(result =>
        {
            if (result)
                history.push('/amorgy/globaltemplates');
            else
            {
                setLoading(false);
                alert('fejl...');
            }
        });
    }

    return (

        <AmorgAdminPageProvider>
            <LoadingPageOverlay loading={loading} />
            <SingleColumnLayout
                noDivider
                headerContainer={
                    <Flex flexDirection="column" gap={16}>
                        <AdminTab selectedTab='globaltemplates' />
                    </Flex>
                }

                contentContainer={
                    <Flex flexDirection="column" gap={16}>
                        <H1>Importér skabelon</H1>
                        <SelectField
                            selectedValue={selectedSite}
                            options={sites.map(s => ({ value: s.id, text: s.id }))}
                            onChange={value => handleSiteChange(value)}
                            label="Valgt site" />


                        <H2>Site skabeloner</H2>
                        <SurveyTemplateList
                            templates={siteTemplates}
                            buttons={[
                                {
                                    variant: 'filled',
                                    text: 'Importér',
                                    onClick: (templateId) => handleClickImport(templateId)
                                }
                            ]} />
                    </Flex>
                }
            />
        </AmorgAdminPageProvider>
    );
}

